// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1KB2a","filesListContainer":"PosDisputesFiles_filesListContainer__rH1u3","filesButton":"PosDisputesFiles_filesButton__2wWf0"};